import { Button } from '#app/components/Buttons/Button.js';
import { CircularIconButton } from '#app/components/Buttons/CircularIconButton.js';
import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const InfoCopy = styled(Text).attrs({ textStyle: 'bodyRegular' })`
  ${({ theme }) => css`
    text-align: center;
    color: ${theme.colorsV2.gray70};
  `}
`;

export const ExternalLinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: 'transparent';
  margin-top: 4px;

  & > * {
    margin-top: 8px;
  }
`;

export const ListContainer = styled.div`
  margin-top: 24px;
`;

export const AddLinkButton = styled(Button)`
  padding: 0 32px;
  margin-top: 24px;
`;

export const LinkCount = styled(Text).attrs({ textStyle: 'captionRegular' })`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};
    padding-bottom: 8px;
    margin-left: 4px;
  `}
`;

export const LinkDivider = styled.div`
  ${({ theme }) => css`
    height: 1px;
    margin: 0 auto;
    background: ${theme.colorsV2.gray30};
    width: 196px;

    ${theme.mediaQueries.md} {
      width: 324px;
    }
  `}
`;

export const UndoButton = styled.button`
  ${({ theme }) => css`
    border: none;
    padding: none;
    color: inherit;
    font-size: inherit;
    text-decoration: underline;

    &:hover {
      color: ${theme.colorsV2.gray20};
    }
  `}
`;

export const EditLinkFormContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    border-radius: 10px;
    padding: 0 16px;

    ${theme.mediaQueries.lg} {
      padding: 0 88px;
    }
  `}
`;

export const LinkForm = styled.div`
  margin-top: 24px;
  width: 100%;
  max-width: 432px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 16px;
`;

export const FormButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;

  & button:first-of-type {
    margin-right: 8px;
  }
`;

export const AddLinkText = styled(Text).attrs({ textStyle: 'bodySmall' })`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};

    ${theme.mediaQueries.lg} {
      font-size: ${theme.textStyles.bodyRegular.fontSize};
      line-height: ${theme.textStyles.bodyRegular.lineHeight};
    }
  `}
`;

export const EditIconButton = styled(CircularIconButton)`
  ${({ theme }) => css`
    width: 32px;
    height: 32px;
    padding: 0;
    box-shadow: ${theme.boxShadow.light};
  `}
`;

export const SidebarEditContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 8px 0;
  width: 100%;

  & > :not(:last-child) {
    margin-right: 16px;
  }
`;
